import { GridCol, TypographyV2 } from "@components/index";
import classNames from "classnames";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import * as styles from "./TrustedByV2.module.scss";
import cn from "classnames";
import { Variant } from "@components/TypographyV2/TypographyV2";

type TrustedByV2Props = {
	trustedByContainerClass?: string;
	logosContainerClass?: string;
	logoClass: string;
	logoTabletClass?: string;
	badges?: boolean;
	rowContainerStylesOverride?: string;
	logosAndPerformerContainerStylesOverride?: string;
	titleMobileVariant?: Variant;
};

export default function TrustedByV2({
	trustedByContainerClass,
	logosContainerClass,
	logoClass,
	logoTabletClass,
	badges = false,
	rowContainerStylesOverride,
	logosAndPerformerContainerStylesOverride,
	titleMobileVariant = "HEADING_4"
}: TrustedByV2Props) {
	return (
		<div className={styles.outerContainer}>
			<GridCol className={styles.colContainer}>
				<div className={cn(styles.rowContainer, rowContainerStylesOverride)}>
					<div
						className={classNames(
							styles.trustedByContainer,
							trustedByContainerClass
						)}
					>
						<TypographyV2
							center
							variant="HEADING_4"
							tabletVariant="HEADING_4"
							mobileVariant={titleMobileVariant}
							color="text-secondary"
							className={styles.title}
						>
							See why thousands of scientists trust Genemod
						</TypographyV2>
					</div>
					<div className={cn(styles.logosAndPerformerContainer, logosAndPerformerContainerStylesOverride)}>
						<div
							className={classNames(
								styles.logosContainer,
								logosContainerClass
							)}
						>
							<StaticImage
								src="./assets/cellectis4x.png"
								alt="Cellectis"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/merck4x.png"
								alt="Merck"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/fred_hutch4x.png"
								alt="Fred Hutch"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/astrazeneca4x.png"
								alt="Astrazeneca"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/thermofisher4x.png"
								alt="Thermo Fisher"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/Berkeley4x.png"
								alt="Berkeley"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/GAInternational4x.png"
								alt="GA International"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/nautilus4x.png"
								alt="Nautilus"
								className={classNames(styles.logo, logoClass)}
							/>
							<StaticImage
								src="./assets/cellectis4x.png"
								alt="Cellectis"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/merck4x.png"
								alt="Merck"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/fred_hutch4x.png"
								alt="Fred Hutch"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/astrazeneca4x.png"
								alt="Astrazeneca"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/thermofisher4x.png"
								alt="Thermo Fisher"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/Berkeley4x.png"
								alt="Berkeley"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/GAInternational4x.png"
								alt="GA International"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
							<StaticImage
								src="./assets/nautilus4x.png"
								alt="Nautilus"
								className={classNames(
									styles.logoTablet,
									logoTabletClass
								)}
							/>
						</div>
						<div className={styles.line}></div>
						{badges === false
						? <HighPerformer
							containerClass={styles.performerContainer}
							badgeClass={styles.performerBadge}
							scoreClass={styles.score}
							starsClass={styles.stars}
						/> :
						<div className={styles.badgeImage}>
							<StaticImage
								loading="eager"
								src={"../Solutions/_assets/LetsTalk.png"}
								alt="solution-g2"
							/>
						</div>
						}
					</div>
				</div>
			</GridCol>
		</div>
	);
}

export const HighPerformer = ({
	containerClass,
	badgeClass,
	scoreClass,
	starsClass,
}: {
	containerClass?: string;
	badgeClass?: string;
	scoreClass?: string;
	starsClass?: string;
}) => {
	return (
		<div className={containerClass}>
			<StaticImage
				src="./assets/high-performer-summer.png"
				alt={`High Performer Summer 2024`}
				className={badgeClass}
			/>
			<div className={scoreClass}>
				<TypographyV2
					center
					variant="BODY_TEXT_EXTRA_LARGE"
					color="text-secondary"
					className={styles.scoreText}
				>
					4.8/5
				</TypographyV2>
				<div className={starsClass}>
					<Star />
					<Star />
					<Star />
					<Star />
					<HalfStar />
				</div>
			</div>
			<StaticImage
				src="./assets/momentum-leader-summer.png"
				alt="Momentum Leader Summer 2024"
				className={badgeClass}
			/>
		</div>
	);
};

const Star = () => {
	return (
		<div style={{ height: 15.4, width: 14.8 }}>
			<svg
				width="15.46"
				height="14.80"
				viewBox="0 0 24 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M11.0554 0.717389C11.3667 -0.178171 12.6333 -0.178173 12.9446 0.717387L15.0631 6.81222C15.2005 7.20729 15.5691 7.47516 15.9873 7.48368L22.4385 7.61515C23.3864 7.63447 23.7778 8.83901 23.0223 9.41181L17.8804 13.3101C17.5471 13.5628 17.4063 13.9962 17.5274 14.3965L19.3959 20.5726C19.6705 21.4801 18.6458 22.2246 17.8676 21.683L12.5712 17.9975C12.2279 17.7586 11.7721 17.7586 11.4288 17.9975L6.13241 21.683C5.35417 22.2246 4.32953 21.4801 4.60408 20.5726L6.47258 14.3965C6.5937 13.9962 6.45287 13.5628 6.11957 13.3101L0.977713 9.41181C0.222181 8.83901 0.613559 7.63447 1.56148 7.61515L8.01268 7.48368C8.43086 7.47516 8.79955 7.20729 8.93687 6.81222L11.0554 0.717389Z"
					fill="#FF492C"
				/>
			</svg>
		</div>
	);
};

const HalfStar = () => {
	return (
		<svg
			width="15.46"
			height="14.80"
			viewBox="0 0 24 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.4723 2.88155L16.5908 8.97638C16.7968 9.56899 17.3499 9.9708 17.9771 9.98358L24.4283 10.115C24.9023 10.1247 25.098 10.727 24.7202 11.0134L19.5784 14.9117C19.0784 15.2907 18.8672 15.9408 19.0488 16.5413L20.9173 22.7174C21.0546 23.1712 20.5423 23.5434 20.1532 23.2726L14.8568 19.587C14.3418 19.2287 13.6582 19.2287 13.1432 19.587L7.84683 23.2726C7.4577 23.5434 6.94538 23.1712 7.08266 22.7174L8.95116 16.5413C9.13283 15.9408 8.92159 15.2907 8.42164 14.9117L3.27979 11.0134C2.90202 10.727 3.09771 10.1247 3.57167 10.115L10.0229 9.98358C10.6501 9.9708 11.2032 9.56899 11.4092 8.97639L13.5277 2.88155C13.6834 2.43377 14.3166 2.43377 14.4723 2.88155Z"
				stroke="#FF492C"
			/>
			<path
				d="M17.5 21V10L14 3L11 10H3.5V11L9.5 16L7.5 23L14 19L17.5 21Z"
				fill="#FF492C"
			/>
		</svg>
	);
};
